const dollarFormat = (value, lang, withDollarSign) => {
    if (value === undefined || value === null || value === '')
        return '';
    const currentLang = lang || 'en';
    const rawValue = String(value);
    const [integerPart, decimalPart] = rawValue.split('.');
    const thousandsSeparator = currentLang === 'fr' ? String.fromCharCode(160) : ',';
    const decimalSeparator = currentLang === 'fr' ? ',' : '.';
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    const hasDecimalSeparator = rawValue.includes('.');
    const formattedValue = hasDecimalSeparator
        ? `${formattedInteger}${decimalSeparator}${decimalPart !== null && decimalPart !== void 0 ? decimalPart : ''}`
        : formattedInteger;
    if (withDollarSign) {
        return `${currentLang === 'en' ? '$ ' : ''}${formattedValue}${currentLang === 'fr' ? ' $' : ''}`;
    }
    return formattedValue;
};
export default dollarFormat;
